import { render, staticRenderFns } from "./PremiumTransformation.vue?vue&type=template&id=8b0bacb4"
import script from "./PremiumTransformation.vue?vue&type=script&lang=js"
export * from "./PremiumTransformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports